/// <reference path="Utilities/_reference.ts" />
/// <reference path="static-map.ts" />

module YVR.PassengerGuides {
	// Dependencies
	import logger = YVR.Utilities.Logger;

	// Cache
	const airlines = [];

	function main() {
		if ($('#yvr-passengerguides-form').length > 0) {
			globalEventBindings();
			setupAirlineList();
			setupAirlinePicker('DOMESTIC|NONE');        // DOMESTIC|NONE is the default choice
		}
	}

	function setupAirlineList() {
		const airlineOptions = $('#yvr-passengerguides-routeairline > option');

		$.each(airlineOptions, function () {
			const airline = {
				name: this.text,
				code: this.value,
				isCanada: this.attributes['data-iscanada'].value === 'True',
				isUS: this.attributes['data-isus'].value === 'True',
				isInternational: this.attributes['data-isinternational'].value === 'True'
			};

			airlines.push(airline);
		});
	}

	function globalEventBindings() {
		$('#yvr-passengerguides-route').on('change', () => {
			setupAirlinePicker($('#yvr-passengerguides-route').val());
		});

		$('#yvr-passengerguides-picker-submit').on('click', function (e) {
			e.preventDefault();

			const form = $(this.form);
			const data = getFormData(form);

			$.post({
				url: '/_services/PassengerGuides/Guide',
				data,
				success: checkResponse
			});
		});
	}

	function eventBindings() {
		$('#yvr-passengerguides-connectionlist-select').on('change', function () {
			YVR.StaticMap.removeAll();

			const connection = $(this).val();
			setActiveConnection(connection);

			YVR.StaticMap.init();
		});

		$('#yvr-passengerguides-connectionlist-tabswitcher button').on('click', function () {
			YVR.StaticMap.removeAll();

			const connection = $(this).attr('data-tab-id');
			setActiveConnection(connection);

			YVR.StaticMap.init();
		});
	}

	function setupAirlinePicker(route) {
		const source = route.substring(0, route.indexOf('|'));
		const destination = route.substring(route.indexOf('|') + 1);

		const airlinePicker = $('#yvr-passengerguides-routeairline');

		let opt;

		if (destination === 'NONE') {
			$('#yvr-passengerguides-routeairline-label')[0].innerHTML = $('#yvr-passengerguides-routeairline-label')[0].attributes['data-arrivinglabel'].value;

			// Filter by source route
			airlinePicker.find('option').remove();

			for (let i = 0; i < airlines.length; i++) {
				if ((source === 'DOMESTIC' && airlines[i].isCanada) || (source === 'US' && airlines[i].isUS) || (source === 'INTERNATIONAL' && airlines[i].isInternational)) {
					opt = document.createElement('option');
					opt.text = airlines[i].name;
					opt.value = airlines[i].code;
					airlinePicker.append(opt);
				}
			}

		} else {
			$('#yvr-passengerguides-routeairline-label')[0].innerHTML = $('#yvr-passengerguides-routeairline-label')[0].attributes['data-departinglabel'].value;

			// Filter by destination route
			airlinePicker.find('option').remove();

			for (let j = 0; j < airlines.length; j++) {
				if ((destination === 'DOMESTIC' && airlines[j].isCanada) || (destination === 'US' && airlines[j].isUS) || (destination === 'INTERNATIONAL' && airlines[j].isInternational)) {
					opt = document.createElement('option');
					opt.text = airlines[j].name;
					opt.value = airlines[j].code;
					airlinePicker.append(opt);
				}
			}
		}
	}

	function getFormData(form) {
		const data = {};

		const inputs = [
			'input[type=text]',
			'input[type=email]',
			'input[type=checkbox]:checked',
			'input[type=radio]:checked',
			'input[type=hidden]',
			'textarea',
			'select'
		];

		form.find(inputs.join(', ')).each(function () {
			if (this.name.length && $(this).attr('disabled') === undefined) {
				data[this.name] = this.value;
			}
		});

		return data;
	}

	function checkResponse(data) {
		YVR.StaticMap.removeAll();

		$('.yvr-passenger-guide-container').empty().append(data);
		eventBindings();
		YVR.StaticMap.init();
	}

	function setActiveConnection(connection) {
		const connectionNum = parseInt(connection, 10);
		let connectionCount = 0;

		logger.log('[passenger-guides][setActiveConnection] Set the active connection.');

		$('.yvr-passenger-guide__connection').each(function () {
			connectionCount++;

			if (connectionCount === connectionNum) {
				$(this).addClass('yvr-passenger-guide__connection--active');
			} else {
				$(this).removeClass('yvr-passenger-guide__connection--active');
			}
		});

		$('#yvr-passengerguides-connectionlist-select').val(connectionNum);

		$('#yvr-passengerguides-connectionlist-tabswitcher button').each(function () {
			const $this = $(this);
			const tabId = parseInt($this.data('tab-id'), 10);

			if (tabId === connectionNum) {
				$this.addClass('yvr-tab-switcher__button--active');
			} else {
				$this.removeClass('yvr-tab-switcher__button--active');
			}
		});
	}

	main();

}
